import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

import { exportTypes } from 'constants/values';
import { sendToAffiliateForExportType } from 'affiliates';
import { setActiveAffiliateOrganizationId } from 'current';
import {
  getActiveOrganizationIdForAffiliateId,
  getActiveScriptId,
  getExportType,
  getSelectAffiliateOrganizationModal
} from 'current/selectors';
import { closeSelectAffiliateOrganizationModal } from 'current/uiwidgets/';

// requesters
import { requestAffiliateList } from 'affiliates/requesters';

// components
import BaseModal from 'common/modals/BaseModal';
import CheckboxRadio from 'common/CheckboxRadio';

const baseString = 'vra-select-affiliate-organization-modal';

class SelectAffiliateOrganizationModalContainer extends Component {

  componentDidMount() {
    this.props.onMount();
  }

  render() {
    const {
      activeAffiliateOrganizationId,
      exportType,
      onSelectAffiliateOrganization,
      onCancelSelectAffiliateOrganizationModal,
      onExportFromSelectAffiliateOrganizationModal,
      scriptId,
      selectAffiliateOrganizationModal
    } = this.props;

    if (!selectAffiliateOrganizationModal) {
      return null;
    }

    const { affiliateId, organizations } = selectAffiliateOrganizationModal;

    const options = organizations.map((organization) => {
      const { id, name } = organization;
      return (
        <CheckboxRadio
          className={`${baseString}__form__input`}
          key={id}
          labelText={name}
          name='affiliateOrganization'
          onChange={() => { onSelectAffiliateOrganization(id); }}
          type="radio"
        />
      );
    });

    return (
      <BaseModal
        header={getMessage('title-text__organization-selector')}
        isInvalid={!activeAffiliateOrganizationId}
        onCancel={() => { onCancelSelectAffiliateOrganizationModal(); }}
        onSave={() => { onExportFromSelectAffiliateOrganizationModal({ affiliateId, exportType, scriptId }); }}
        saveText={getMessage(`button-text__export--${affiliateId}`, { connected: true } )}>

        <section className={`${baseString}__body`}>
          <form className={`${baseString}__form`}>
            <legend className={`${baseString}__form__legend`}>
              {getMessage('title-text__organization-selector')}
            </legend>
            {options}
          </form>
        </section>

      </BaseModal>
    );
  }
}

SelectAffiliateOrganizationModalContainer.propTypes = {
  activeAffiliateOrganizationId: propTypes.string,
  exportType: propTypes.oneOf(Object.values(exportTypes)),
  onCancelSelectAffiliateOrganizationModal: propTypes.func.isRequired,
  onExportFromSelectAffiliateOrganizationModal: propTypes.func.isRequired,
  onMount: propTypes.func.isRequired,
  onSelectAffiliateOrganization: propTypes.func.isRequired,
  scriptId: propTypes.string,
  selectAffiliateOrganizationModal: propTypes.shape({
    affiliateId: propTypes.string.isRequired,
    organizations: propTypes.arrayOf(
      propTypes.shape({
        id: propTypes.string.isRequired,
        name: propTypes.string.isRequired
      })
    )
  })
};

SelectAffiliateOrganizationModalContainer = connect(
  (state) => {
    return {
      activeAffiliateOrganizationId: getActiveOrganizationIdForAffiliateId(state),
      exportType: getExportType(state),
      selectAffiliateOrganizationModal: getSelectAffiliateOrganizationModal(state),
      scriptId: getActiveScriptId(state)
    };
  },
  (dispatch) => {
    return {
      onCancelSelectAffiliateOrganizationModal: () => dispatch(closeSelectAffiliateOrganizationModal()),
      onExportFromSelectAffiliateOrganizationModal: ({ affiliateId, exportType, scriptId }) =>
        dispatch(sendToAffiliateForExportType({ affiliateId, exportType, scriptId })),
      onSelectAffiliateOrganization: (affiliateOrganizationId) =>
        dispatch(setActiveAffiliateOrganizationId(affiliateOrganizationId)),
      onMount: () => {
        dispatch(requestAffiliateList());
      }
    };
  }
)(SelectAffiliateOrganizationModalContainer);
export default SelectAffiliateOrganizationModalContainer;
